import { defineComponent as _defineComponent } from 'vue'
import { Box } from '@/ui/components/Box';
  import DarkContactUs from '@/ui/components/button/DarkContactUs.vue';
  import YoutubeIframe from '@/ui/components/common/YoutubeIframe.vue';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalsForbidden',
  setup(__props) {

  
return { __sfc: true,Box, DarkContactUs, YoutubeIframe, PageSubtitle }
}

})